import React from "react";
import { STATUS_LABELS } from "@/lib/api";

const STATUS_STYLES = {
  // stock
  received: "bg-stone-100 text-stone-800 border-stone-200",
  pending_processing: "bg-amber-100 text-amber-800 border-amber-200",
  processing: "bg-orange-100 text-orange-800 border-orange-200",
  processed: "bg-emerald-100 text-emerald-800 border-emerald-200",
  awaiting_paint: "bg-fuchsia-100 text-fuchsia-800 border-fuchsia-200",
  available: "bg-green-100 text-green-800 border-green-200",
  allocated: "bg-blue-100 text-blue-800 border-blue-200",
  dispatched: "bg-yellow-100 text-yellow-800 border-yellow-200",
  damaged: "bg-red-100 text-red-800 border-red-200",
  written_off: "bg-stone-200 text-stone-500 border-stone-300 line-through",
  // orders
  draft: "bg-stone-100 text-stone-700 border-stone-200",
  open: "bg-sky-100 text-sky-800 border-sky-200",
  partially_allocated: "bg-blue-50 text-blue-700 border-blue-200",
  fully_allocated: "bg-blue-100 text-blue-800 border-blue-300",
  ready_for_dispatch: "bg-violet-100 text-violet-800 border-violet-200",
  partially_dispatched: "bg-amber-100 text-amber-800 border-amber-300",
  invoiced: "bg-emerald-100 text-emerald-800 border-emerald-200",
  closed: "bg-stone-200 text-stone-700 border-stone-300",
  cancelled: "bg-rose-100 text-rose-800 border-rose-200",
  // invoice
  issued: "bg-sky-100 text-sky-800 border-sky-200",
  paid: "bg-emerald-100 text-emerald-800 border-emerald-200",
  partially_paid: "bg-amber-100 text-amber-800 border-amber-200",
  overdue: "bg-red-100 text-red-800 border-red-200",
};

export function StatusBadge({ status, labels, "data-testid": dti }) {
  const style = STATUS_STYLES[status] || "bg-stone-100 text-stone-700 border-stone-200";
  const label = (labels && labels[status]) || STATUS_LABELS[status] || status;
  return (
    <span
      className={`inline-flex items-center gap-1 rounded-full border px-2 py-0.5 text-xs font-semibold ${style}`}
      data-testid={dti || `status-${status}`}
    >
      <span className="h-1.5 w-1.5 rounded-full bg-current opacity-70" />
      {label}
    </span>
  );
}
